export default {
  AI: 'AI',
  ONLINE: 'ONLINE',
  DEVICE: 'DEVICE',
};
